import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class LabelLinkQueryCriteriaClass extends BaseCriteriaModel {
  guid?: Optional<string> = Optional.empty();
  guid_label_hdr?: Optional<string> = Optional.empty();
  header_table?: Optional<string> = Optional.empty();
  line_table?: Optional<string> = Optional.empty();
  guid_hdr?: Optional<string> = Optional.empty();
  guid_line?: Optional<string> = Optional.empty();
}

export class LabelLinkCriteriaModelQuery {
  query = '';

  constructor(LabelLinkCriteriaModel: LabelLinkQueryCriteriaClass) {

    if (!LabelLinkCriteriaModel) {
      return;
    }

    this.query += LabelLinkCriteriaModel.guid.filter(x => x !== '').map(x => '&guid=' + x).orElse('');
    this.query += LabelLinkCriteriaModel.guid_label_hdr.filter(x => x !== '').map(x => '&guid_parent=' + x).orElse('');
    this.query += LabelLinkCriteriaModel.header_table.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += LabelLinkCriteriaModel.line_table.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += LabelLinkCriteriaModel.guid_hdr.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += LabelLinkCriteriaModel.guid_line.filter(x => x !== '').map(x => '&descr=' + x).orElse('');

    this.query += '&status=' + LabelLinkCriteriaModel.status;
    this.query += '&orderBy=' + LabelLinkCriteriaModel.orderBy;
    this.query += '&order=' + LabelLinkCriteriaModel.order;
    this.query += '&offset=' + LabelLinkCriteriaModel.offset + '&limit=' + LabelLinkCriteriaModel.limit;
  }
}
